'use memo'

import type { FinderPreference } from '@sportninja/common/features/profile/finderSettings/types'
import {
  getGenericSportById,
  getSportById,
} from '@sportninja/common/selectors/types'
import { useSelector } from 'src/hooks/useRedux'

interface SportLike {
  name_full?: string | null
  name?: string | null
}

/**
 * Resolves a finder preference's sport display name from the Redux `types` store.
 * Prefers the generic (basic-stats) sport name via `generic_sport_id`, falling
 * back to the full-stats sport via `sport_id`, then the denormalized
 * `sport_name`/`sport_id` on the preference itself.
 */
export const useSportName = (
  preference: Pick<
    FinderPreference,
    'sport_id' | 'generic_sport_id' | 'sport_name'
  > | null
): string => {
  const sport = useSelector<SportLike | null>((state) => {
    if (!preference) {
      return null
    }
    return (
      (getGenericSportById(state, preference.generic_sport_id) as SportLike) ||
      (getSportById(state, preference.sport_id) as SportLike) ||
      null
    )
  })

  if (!preference) {
    return ''
  }

  return (
    sport?.name_full ||
    sport?.name ||
    preference.sport_name ||
    preference.sport_id
  )
}
